export default __webpack_public_path__ + "static/6835-4be841d85043a0a716ba55513863d1e6.jpg";